export const DataTypes = {
    boolean: 'Boolean',
    integer: 'Integer',
    float:   'Float',
    text:    'Text'
};

export const Intervals = [5, 10, 15, 30, 60];

export const BacNetTypes = [
    {
        type: 'AnalogInput',
        data: 'float'
    },
    {
        type: 'AnalogOutput',
        data: 'float'
    },
    {
        type: 'AnalogValue',
        data: 'float'
    },
    {
        type: 'BinaryInput',
        data: 'boolean'
    },
    {
        type: 'BinaryOutput',
        data: 'boolean'
    },
    {
        type: 'BinaryValue',
        data: 'boolean'
    },
    {
        type: 'MultiStateInput',
        data: 'integer'
    },
    {
        type: 'MultiStateOutput',
        data: 'integer'
    },
    {
        type: 'MultiStateVariable',
        data: 'integer'
    },
    {
        type: 'Absorber_UCP2',
        data: 'integer'
    },
    {
        type: 'Area',
        data: 'integer'
    },
    {
        type: 'Calculation',
        data: 'integer'
    },
    {
        type: 'CCP',
        data: 'integer'
    },
    {
        type: 'CCP_Group',
        data: 'integer'
    },
    {
        type: 'CCP_VAVUCM',
        data: 'integer'
    },
    {
        type: 'Centravac_UCP1',
        data: 'integer'
    },
    {
        type: 'Centravac_UCP2',
        data: 'integer'
    },
    {
        type: 'CGA_CGW',
        data: 'integer'
    },
    {
        type: 'Chir_LonTalk',
        data: 'integer'
    },
    {
        type: 'CPC',
        data: 'integer'
    },
    {
        type: 'CPL',
        data: 'integer'
    },
    {
        type: 'CSC',
        data: 'integer'
    },
    {
        type: 'DAC',
        data: 'integer'
    },
    {
        type: 'HeatPmpLoopCntrl',
        data: 'integer'
    },
    {
        type: 'Horizon_Absorber',
        data: 'integer'
    },
    {
        type: 'IPak',
        data: 'integer'
    },
    {
        type: 'MP580',
        data: 'integer'
    },
    {
        type: 'PCM',
        data: 'integer'
    },
    {
        type: 'RTA_RTW',
        data: 'integer'
    },
    {
        type: 'RTHB_Helical',
        data: 'integer'
    },
    {
        type: 'SCC_1H1C',
        data: 'integer'
    },
    {
        type: 'SCC_AHU',
        data: 'integer'
    },
    {
        type: 'SCC_BlowerCoil',
        data: 'integer'
    },
    {
        type: 'SCC_FanCoil_ZN520',
        data: 'integer'
    },
    {
        type: 'SCC_FanCoil_ZN523',
        data: 'integer'
    },
    {
        type: 'SCC_HeatPump',
        data: 'integer'
    },
    {
        type: 'SCC_RTU',
        data: 'integer'
    },
    {
        type: 'SCC_Unitary',
        data: 'integer'
    },
    {
        type: 'SCC_UnitVentilator',
        data: 'integer'
    },
    {
        type: 'SCC_VAV',
        data: 'integer'
    },
    {
        type: 'SCC_VertSelfCont',
        data: 'integer'
    },
    {
        type: 'TCM',
        data: 'integer'
    },
    {
        type: 'TracerLoopCtrl',
        data: 'integer'
    },
    {
        type: 'TUC',
        data: 'integer'
    },
    {
        type: 'UPCM',
        data: 'integer'
    },
    {
        type: 'VAS_2_3_4',
        data: 'integer'
    },
    {
        type: 'VAS_LonTalk',
        data: 'integer'
    },
    {
        type: 'VAV1',
        data: 'integer'
    },
    {
        type: 'VAVUCM_2_3_4',
        data: 'integer'
    },
    {
        type: 'Voyager_Comm3_4',
        data: 'integer'
    },
    {
        type: 'Voyager_3',
        data: 'integer'
    }
];

export const NiagaraTypes = [
    {
        type: 'BcpBacnetBooleanWritable',
        data: 'boolean'
    },
    {
        type: 'BcpBacnetNumericWritable',
        data: 'float'
    },
    {
        type: 'BcpBacnetEnumWritable',
        data: 'text'
    },
    {
        type: 'BooleanPoint',
        data: 'boolean'
    },
    {
        type: 'BooleanSchedule',
        data: 'boolean'
    },
    {
        type: 'BooleanWritable',
        data: 'boolean'
    },
    {
        type: 'EnumPoint',
        data: 'text'
    },
    {
        type: 'EnumSchedule',
        data: 'text'
    },
    {
        type: 'EnumWritable',
        data: 'text'
    },
    {
        type: 'NumericPoint',
        data: 'float'
    },
    {
        type: 'NumericSchedule',
        data: 'float'
    },
    {
        type: 'NumericWritable',
        data: 'float'
    },
    {
        type: 'StringPoint',
        data: 'text'
    },
    {
        type: 'StringSchedule',
        data: 'text'
    },
    {
        type: 'StringWritable',
        data: 'text'
    }
];
